import React, { Component } from 'react';
import Yasgui from './Yasgui';
import { Input, FormGroup, Label } from 'reactstrap';
import AceEditor from 'react-ace';
// import MonacoEditor from 'react-monaco-editor';
// import brace from 'brace';

import 'brace/mode/javascript';
import 'brace/theme/github';
// import styles from './FormField.module.css';

class FormField extends Component {
  onChange = e => {
    let name = this.props.name;
    let value = e.target.value;
    if (this.props.type === 'array') {
      value = value.split(',');
    }
    this.props.onChange(name, value);
  };

  render() {
    let type = this.props.type;
    if (type === 'yasgui') {
      return (
        <FormGroup>
          <Label>{this.props.label}</Label>
          <Yasgui
            value={this.props.value}
            handleBlur={value => {
              this.props.onChange(this.props.name, value);
            }}
          />
        </FormGroup>
      );
    } else if (type === 'javascript') {
      return (
        <FormGroup>
          <Label>{this.props.label}</Label>
          <AceEditor
            mode="javascript"
            theme="github"
            style={{width: '100%', height: '120px'}}
            value={this.props.value}
            onChange={newValue => {
              this.props.onChange(this.props.name, newValue);
            }}
            name="editor"
          />
        </FormGroup>
      );
    } else if (type === 'select') {
      return (
        <FormGroup>
          <Label>{this.props.label}</Label>
          <Input className="dark-form-control" value={this.props.value || ''} type={type} onChange={this.onChange}>
            {type === 'select' &&
              this.props.options &&
              this.props.options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </Input>
        </FormGroup>
      );
    } else if (type === 'boolean') {
      return (
        <FormGroup>
          <Label style={{ cursor: 'pointer' }}>
            <Input
              checked={this.props.value || false}
              style={{ marginLeft: '0', marginRight: '6px', position: 'relative' }}
              type="checkbox"
              onChange={e => this.props.onChange(this.props.name, e.target.checked)}
            />
            {'  ' + this.props.label}
          </Label>
        </FormGroup>
      );
    } else {
      return (
        <FormGroup>
          <Label>{this.props.label}</Label>
          <Input className="dark-form-control" value={this.props.value || ''} type={type} onChange={this.onChange} />
        </FormGroup>
      );
    }
  }
}

export default FormField;
